
import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

import ChevronRight from '@src/assets/icons/chevron-down.svg';
import CoinIcon from '@src/assets/icons/ic_coin.svg';
import SeminarIcon from '@src/assets/icons/ic_seminaras.svg';
import ReadingsIcon from '@src/assets/icons/ic_skaitiniai.svg';
import VideoIcon from '@src/assets/icons/ic_video.svg';

import api from '@src/utils/api';

const typeMap = {
  default: {
    color: '#acacac',
    icon: '',
    text: '',
  },
  video: {
    color: '#fc7777',
    icon: <VideoIcon />,
    text: 'Video',
  },
  seminar: {
    color: '#beb2ff',
    icon: <SeminarIcon />,
    text: 'Seminaras',
  },
  readings: {
    color: '#98eac8',
    icon: <ReadingsIcon />,
    text: 'Skaitiniai',
  },
};

const materialCard = ({ title, authorName, authorLink, type, slug, price }) => {
  const { t, i18n } = useTranslation();
  const [author, setAuthor] = useState();

  const cardType = typeMap[type || 'default'];

  useEffect(() => {
    const controller = new AbortController();
    const loadTeacherName = async (id) => {
      const res = await api.get(`teachers/${id}`, {
        controller,
      });
      setAuthor(res.displayName);
    };

    if (Number(authorName) > 0) {
      loadTeacherName(Number(authorName));
    } else {
      setAuthor(authorName);
    }

    return () => controller?.abort();
  }, []);

  return (
    <Flex
      className="material-card"
      sx={{
        flexDirection: 'column',
        padding: '26px 32px',
        position: 'relative',
        cursor: 'pointer',
      }}
      tabIndex="0"
      onClick={() => {
        navigate(`/${slug}`);
      }}
    >
      <Box className="material-card__bg"></Box>
      <Flex>
        {cardType.icon && <Box mb={3}>{cardType.icon}</Box>}

        <span sx={{ marginLeft: 'auto', color: 'label' }}>{cardType.text}</span>
      </Flex>

      <Themed.a
        sx={{
          textDecoration: 'none',
          marginBottom: 2,
          display: 'inline-block',
          '&:before': {
            content: '""',
            lineHeight: '1em',
            display: 'inline-block',
          },
        }}
      >
        {author}
      </Themed.a>

      <Themed.h4 sx={{ marginTop: 0, lineHeight: 1.2 }}>{title}</Themed.h4>
      <Flex sx={{ alignItems: 'center', marginTop: 'auto' }} mt={4}>
        <Flex sx={{ alignItems: 'center' }}>
          <CoinIcon />
          <Box sx={{ marginLeft: 2, color: 'text700', fontSize: 3 }}>
            {price}
          </Box>
        </Flex>

        <ChevronRight
          sx={{
            marginLeft: 'auto',
            position: 'relative',
            right: '-10px',
            transform: 'rotate(-90deg)',
          }}
        />
      </Flex>

      <Box className="material-card__type-corner">
        <Box
          sx={{
            borderRight: '36px solid transparent',
            borderBottom: `36px solid ${cardType.color}`,
          }}
        />
      </Box>
    </Flex>
  );
};

export default materialCard;
